import React, { useContext } from 'react'
import { useSelector } from 'hooks/use-redux'
import type { ParentProps } from 'types/explorer'
import type { Track } from 'types/track'
import { PaneContext } from 'contexts/pane'
import {
  getNestedStems,
  getNestedVersions,
} from '@disco/state-management/selectors/nesting'
export type TrackVersionsProps = {
  mainTrack: Track
  currentTrack: Track
  currentTrackIndex?: number
  versions: Track[] | null | undefined
  stems: Track[] | null | undefined
  parentProps: ParentProps
}

// TODO: can be rewritten as a hook
const TrackVersionsContainer = (props: {
  parentProps?: ParentProps
  component: (...args: Array<any>) => any
  mainTrack?: Track
  currentTrackIndex?: number
}): React.ReactNode => {
  const { component, mainTrack: propMainTrack, currentTrackIndex } = props
  const paneContext = useContext(PaneContext)
  const parentProps = props.parentProps || paneContext.parentProps
  // TODO: use PaneContext instead of passing parentProps prop
  const currentTrack = parentProps?.pane
  const mainTrackId = currentTrack?.nesting_parent_id || currentTrack?.id
  let mainTrack = useSelector(state => state.tracks[mainTrackId])

  if (propMainTrack) {
    mainTrack = propMainTrack
  }

  let versions = useSelector(state => getNestedVersions(state, mainTrack || {}))

  if (versions.length === 0) {
    versions = null
  }

  let stems = useSelector(state => getNestedStems(state, mainTrack || {}))

  if (stems.length === 0) {
    stems = null
  }

  return React.createElement(component, {
    parentProps,
    mainTrack,
    currentTrack,
    versions,
    stems,
    currentTrackIndex,
  })
}

export default TrackVersionsContainer
